export default "__VITE_ASSET__BhDAn1Ll__"